import { apiFetch } from "./client";

export interface Shortcut {
  id: string;
  title: string;
  icon: string;
  to: string;
  badge?: string | null;
  external?: boolean;
}

export interface ShortcutCategoria {
  id: string;
  label: string;
}

export const listShortcuts = () =>
  apiFetch<Shortcut[]>("/api/v1/herramientas/shortcuts");

export const listCategorias = () =>
  apiFetch<ShortcutCategoria[]>("/api/v1/herramientas/categorias");
